import React from 'react';
import { colors } from '../../themes/colors';

function CorrectedValue(props) {
  const {
    originValue,
    correctedValue,
    originClassName,
    correctedClassName,
    originStyle,
    correctedStyle,
    blur = false,
  } = props;

  const blurStyle = blur ? { color: 'transparent', textShadow: '0 0 10px rgba(0,0,0,0.6)' } : {};
  const differenceValue = !!correctedValue && originValue?.toLowerCase() !== correctedValue?.toLowerCase();
  return (
    <>
      <div className={originClassName}
           style={{ ...originStyle, textDecoration: differenceValue && 'line-through', ...blurStyle }}
      >
        {originValue}
      </div>
      {differenceValue && (
        <div className={correctedClassName || originClassName}
             style={{
               ...(correctedStyle ? correctedStyle : originStyle),
               color: colors.green,
               ...blurStyle
             }}
        >
          {correctedValue}
        </div>
      )}
    </>
  );
}

export default CorrectedValue;
